import api from '../api';
import { Resource, ResourceStats, PaginationParams, PaginationResponse } from '../../types';

interface ResourceListParams extends PaginationParams {
  type?: string;
  status?: string;
  verified?: string;
}

interface ResourceListResponse {
  resources: Resource[];
  pagination: PaginationResponse;
}

export const resourceService = {
  async getAll(params?: ResourceListParams): Promise<ResourceListResponse> {
    const queryParams = new URLSearchParams();
    if (params?.page) queryParams.append('page', params.page.toString());
    if (params?.limit) queryParams.append('limit', params.limit.toString());
    if (params?.search) queryParams.append('search', params.search);
    if (params?.type) queryParams.append('type', params.type);
    if (params?.status) queryParams.append('status', params.status);
    if (params?.verified) queryParams.append('verified', params.verified);
    
    const response = await api.get(`/admin/resources?${queryParams.toString()}`);
    return response.data;
  },

  async getById(id: string): Promise<Resource> {
    const response = await api.get(`/admin/resources/${id}`);
    return response.data;
  },

  async create(data: Omit<Resource, 'id' | 'createdAt' | 'updatedAt'>): Promise<Resource> {
    const response = await api.post('/admin/resources', data);
    return response.data;
  },

  async update(id: string, data: Partial<Resource>): Promise<Resource> {
    const response = await api.put(`/admin/resources/${id}`, data);
    return response.data;
  },

  async verify(id: string, verified: boolean): Promise<Resource> {
    const response = await api.put(`/admin/resources/${id}/verify`, { verified });
    return response.data;
  },

  async updateStatus(id: string, isActive: boolean): Promise<Resource> {
    const response = await api.put(`/admin/resources/${id}/status`, { isActive });
    return response.data;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/admin/resources/${id}`);
  },

  async getStats(): Promise<ResourceStats> {
    const response = await api.get('/admin/resources/stats/overview');
    return response.data;
  },
};
